import React from "react";

export default function Footer() {
  return (
    <div className="mt-auto mx-auto mb-4 pt-2">
      <p className="text-lg text-gray-700">© Lakshitha Pramodya</p>
    </div>
  );
}
